import axios from "@/utils/AxiosInstance.js"

export const calls = {
  namespaced: true,
  state: {
    callDataRetrievedLoadingErrorStatus: false,
    callDataRetrievedLoadingError: "",
    callDataRetrievedLoadingStatus: "notLoading",
    callDataRetrieved: {},
  },
  mutations: {
    SET_CALL_DATA_RETRIEVED_LOADING_ERROR_STATUS(state, status) {
      state.callDataRetrievedLoadingErrorStatus = status
    },
    SET_CALL_DATA_RETRIEVED_LOADING_ERROR(state, error) {
      state.callDataRetrievedLoadingError = error
    },
    SET_CALL_DATA_RETRIEVED_LOADING_STATUS(state, status) {
      state.callDataRetrievedLoadingStatus = status
    },
    SET_CALL_DATA_RETRIEVED(state, callDataRetrieved) {
      state.callDataRetrieved = callDataRetrieved
    },
  },
  getters: {
    callDataRetrievedLoadingErrorStatus: state => state.callDataRetrievedLoadingErrorStatus,
    callDataRetrievedLoadingError: state => state.callDataRetrievedLoadingError,
    callDataRetrievedLoadingStatus: state => state.callDataRetrievedLoadingStatus,
    callDataRetrieved: state => state.callDataRetrieved,
  },
  actions: {

    retrieveCallData(context, payload) {
      let axios_params = {params:{}}
      let call_url = process.env.VUE_APP_CALL_RECORDS + payload.call_id

      if(payload.selfSigned) {
        call_url = process.env.VUE_APP_AUTHENTICATE_ROUTE + payload.call_id
        axios_params['params']['route'] = 'call-records'
        axios_params['params']['call_id'] = payload.call_id
        axios_params['headers'] = {"Authorization": payload.userid + " " + payload.reckey}
      }

      context.commit("SET_CALL_DATA_RETRIEVED_LOADING_STATUS", "loading");
      axios
        .get(call_url, axios_params)
        .then(response => {

            let callData = response.data

            // note and has_tags logic copied from lg-call-service...
            callData.note_id = (callData.note) ? callData.note.id : null
            callData.note_is_blank = (!callData.note || callData.note.note == "") ? true : false
            callData.has_tags = callData.tags.length > 0

            context.commit("SET_CALL_DATA_RETRIEVED", callData);
            context.commit("SET_CALL_DATA_RETRIEVED_LOADING_STATUS", "loaded");
            context.commit("SET_CALL_DATA_RETRIEVED_LOADING_ERROR_STATUS", false);
            context.commit("SET_CALL_DATA_RETRIEVED_LOADING_ERROR", "");
        })
        .catch(function (error) {
          context.commit("SET_CALL_DATA_RETRIEVED", {});
          context.commit("SET_CALL_DATA_RETRIEVED_LOADING_STATUS", "failed");
          context.commit("SET_CALL_DATA_RETRIEVED_LOADING_ERROR_STATUS", true);
          let error_message = JSON.stringify(error)
          if (error.hasOwnProperty(error) && error.error.hasOwnProperty('message')) error_message = error.error.message
          if (error.hasOwnProperty(error) && error.error.hasOwnProperty('code')) error_message += ` (${error.error.code})`
          context.commit("SET_CALL_DATA_RETRIEVED_LOADING_ERROR", 'retrieveCallData(): ' + error_message)
        });
    }
  }
};
